/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function RequestBodyExportCommonFromJSON(json) {
    return RequestBodyExportCommonFromJSONTyped(json, false);
}
export function RequestBodyExportCommonFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        basicResourceListId: !exists(json, 'basic_resource_list_id') ? undefined : json['basic_resource_list_id'],
        isSendEmail: !exists(json, 'is_send_email') ? undefined : json['is_send_email']
    };
}
export function RequestBodyExportCommonToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        basic_resource_list_id: value.basicResourceListId,
        is_send_email: value.isSendEmail
    };
}
